import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { ChemicalRecord, Warehouse } from '@/types/Component';
import { toCamel } from 'snake-camel';

type Chemical = {
    id: string
    displayName: string;
    unitName: string;
    warehouseId: string;
    warehouseName: string;
}

@Component({
    components: {
        Modal
    }
})
export default class SelectChemicals extends Vue {
    private baseUrl = '/warehouses'
    private warehouses: Warehouse[] = []
    private initialWarehouse: Warehouse = {
        id: "",
        name: "",
        chemicals: [],
        fertilizers: [],
        depreciationMaterials: [],
        expendableMaterials: [],
        isHidden: false
    }
    private selectedWarehouse: Warehouse = this.initialWarehouse
    private displayChemicals: { id: number; displayName: string; unitName: string; }[] = []
    private selectedChemicals: Chemical[] = []
    private searchWord = ""
    private displayWarehouses: Warehouse[] = []

    @Prop()
    private value!: boolean

    @Prop({
        required: true
    })
    private preSelectItem!: ChemicalRecord[]

    @Emit('input')
    private input(value: boolean) {
        value
    }

    @Emit('close')
    private save() {
        return this.selectedChemicals.map(chemical => ({
            warehouseId: chemical.warehouseId,
            warehouseName: chemical.warehouseName,
            chemicalId: chemical.id,
            chemicalDisplayName: chemical.displayName,
            chemicalUnitName: chemical.unitName
        }))
    }

    @Emit('cancel')
    private cancel() {
        // 初期化処理
        this.searchWord = ""
        this.displayChemicals = []
        this.selectedChemicals = []
        this.selectedWarehouse = this.initialWarehouse
    }

    @Watch('value')
    private onOpenModal() {
        if (this.value) {
            // 初期化処理
            this.searchWord = ""
            this.displayChemicals = []
            this.selectedChemicals = []
            this.displayWarehouses = []
            this.selectedWarehouse = this.initialWarehouse
            this.getWarehouses()
        }
    }

    get isModalVisible(): boolean {
        return this.value;
    }

    set isModalVisible(value: boolean) {
        this.input(value);
    }

    private getWarehouses() {
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=false`).then(ret => {
            this.warehouses = this.displayWarehouses = (toCamel(ret) as { warehouses: Warehouse[] }).warehouses.map(warehouse => ({
                id: warehouse.id,
                name: warehouse.name,
                chemicals: warehouse.chemicals.map(chemical => ({
                    id: chemical.id,
                    displayName: chemical.displayName  ,
                    unitName: chemical.unitName,
                    warehouseId: warehouse.id,
                    warehouseName: warehouse.name
                })),
                fertilizers: warehouse.fertilizers,
                depreciationMaterials: warehouse.depreciationMaterials,
                expendableMaterials: warehouse.expendableMaterials,
                isHidden: warehouse.isHidden
            }))
            if (this.preSelectItem?.length) {
                // 渡された農薬を選択済みにする
                this.selectedChemicals = this.preSelectItem.map(item => ({
                    id: item.chemicalId,
                    displayName: item.chemicalDisplayName,
                    unitName: item.chemicalUnitName,
                    warehouseId: item.warehouseId,
                    warehouseName: item.warehouseName
                }))

                // 最初に選択された倉庫を選択状態にする
                this.selectedWarehouse = this.warehouses.find(warehouse => warehouse.id === this.selectedChemicals[0]?.warehouseId) || this.initialWarehouse
                this.displayChemicals = this.selectedWarehouse.chemicals
            } else {
                // 先頭の倉庫を選択状態にする
                this.selectedWarehouse = this.warehouses[0]
                this.displayChemicals = this.selectedWarehouse.chemicals
            }
        })
    }

    private selectWarehouse(warehouse: Warehouse) {
        this.selectedWarehouse = warehouse
        this.displayChemicals = warehouse.chemicals
        this.filteringChemicals()
    }

    private filteringChemicals() {
        this.displayChemicals = this.warehouses.find(warehouse => this.selectedWarehouse.id === warehouse.id)?.chemicals.filter(chemical => chemical.displayName.indexOf(this.searchWord) > -1) || []
    }

    private search() {
        this.displayWarehouses = this.warehouses.filter(warehouse => warehouse.chemicals.filter(chemical => chemical.displayName.indexOf(this.searchWord) > -1).length)
        this.filteringChemicals()
    }
}